import { render, staticRenderFns } from "./JobDescriptionList.vue?vue&type=template&id=3b7a0818&"
import script from "./JobDescriptionList.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports